import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import tiktokSrc from '@arelia-assets/tiktok_primary.svg';
import PublicIcon from '@mui/icons-material/Public';

const styles = {
  icon: {
    fontSize: "30px"
  },
  imageIcon: {
    width: "30px",
    height: "30px"
  }
};

export const iconsMap: {[key: string]: JSX.Element} = {
  facebook: <FacebookOutlinedIcon color="primary" sx={styles.icon} />,
  instagram: <InstagramIcon color="primary" sx={styles.icon} />,
  twitter: <TwitterIcon color="primary" sx={styles.icon} />,
  youtube: <YouTubeIcon color="primary" sx={styles.icon} />,
  website: <PublicIcon color="primary" sx={styles.icon} />,
  tiktok: <img src={tiktokSrc} alt="tiktok" style={styles.imageIcon} />
};

export const formConfig = [{
  label: "Facebook",
  field: "facebook"
}, {
  label: "Instagram",
  field: "instagram"
}, {
  label: "Twitter",
  field: "twitter"
}, {
  label: "YouTube",
  field: "youtube"
}, {
  label: "TikTok",
  field: "tiktok"
}, {
  label: "Website",
  field: "website"
}];